module.exports = __webpack_public_path__ + "static/media/info.5d9127a6.svg";